module.exports = __webpack_public_path__ + "img/unamused.79ebfe82.png";